import React from 'react';
import InsurancePartners from '../components/layout/InsurancePartners';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <div className="about-hero">
        <div className="about-hero-overlay" />
        <div className="about-banner">
          <div className="about-banner-content">
            <h1>About Us</h1>
          </div>
        </div>
      </div>

      <section className="about-intro">
        <div className="container">
          <div className="intro-content">
            <h2>Welcome to BeReliable Insurance</h2>
            <p>
              At BeReliable Insurance, we understand that insurance is more than just a policy—it's a promise of security and peace of mind. Based in Vadodara, Gujarat, we are committed to providing comprehensive insurance solutions that protect what matters most to you.
            </p>
            <p>
              Our mission is to make insurance accessible, transparent, and reliable for everyone. We believe in building long-term relationships with our clients based on trust, integrity, and exceptional service.
            </p>
          </div>
        </div>
      </section>

      <section className="trust-section">
        <div className="container">
          <h2 className="section-title">The Trust Concept</h2>
          <div className="trust-content">
            <p>
              Trust is the foundation of everything we do. In the insurance industry, trust means:
            </p>
            <ul className="trust-list">
              <li>Transparent communication about policies and coverage</li>
              <li>Honest assessment of your insurance needs</li>
              <li>Reliable support when you need it most</li>
              <li>Fair and prompt claim settlements</li>
              <li>Protection of your personal information</li>
            </ul>
            <p>
              We earn your trust every day through our actions, not just our words. Your security and satisfaction are our top priorities.
            </p>
          </div>
        </div>
      </section>

      <section className="mission-vision">
        <div className="container">
          <div className="mv-grid">
            <div className="mv-card card">
              <h3>Our Mission</h3>
              <p>
                To provide accessible, transparent, and reliable insurance solutions that protect our clients' assets, health, and financial well-being. We strive to make insurance simple, understandable, and affordable for everyone.
              </p>
            </div>
            <div className="mv-card card">
              <h3>Our Vision</h3>
              <p>
                To become the most trusted insurance partner in Gujarat and beyond, known for our integrity, customer-centric approach, and innovative solutions that meet the evolving needs of our clients.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="about-partners-section">
        <InsurancePartners variant="grid" />
      </div>
    </div>
  );
};

export default About;


